import { usePm2Modal } from '@pm2/ui-lightbox';
import { ReadingPaneIcon } from '@ui/kit/icons';
import { UniversalContextMenuButton } from '@utils/component-framework';
import { jsx } from 'react/jsx-runtime';

function LightboxButton({
  node,
  speechFile,
  onClick
}) {
  const modal = usePm2Modal();
  const handleClick = () => {
    modal.fromAST([node], {
      disableSpeechSynthesisButton: !!speechFile
    });
    onClick?.();
  };
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "button",
    label: "\xC5bn i l\xE6serude",
    onClick: handleClick,
    icon: /*#__PURE__*/jsx(ReadingPaneIcon, {})
  });
}

export { LightboxButton };
//# sourceMappingURL=lightbox-button.js.map
